
export default {
  name: 'FilterTextField',
  props: {
    value: { type: String, default: '' },
    placeHolder: { type: String, default: '수업명, 선생님 검색' },
    height: { type: Number, default: 40 },
  },
  mounted() {
    if (this.$route.params?.autoFocus) {
      this.$refs.keywordInput?.focus();
    }
  },
  methods: {
    updateValue(v) {
      this.$emit('input', v);
    },
    onKeydownEnter(e) {
      if (e.isComposing) return;
      this.$refs.keywordInput.blur();
      this.$emit('search-keyword');
    },
    onClickCleanButton() {
      if (this.value) this.$emit('clean');
    },
    onClickSearchButton() {
      this.$emit('search-keyword');
    },
  },
};
